export const INIT_MAP = 'INIT_MAP'
export const SET_CENTER = 'SET_CENTER'
export const TOGGLE_GUIDE = 'TOGGLE_GUIDE'
export const SET_MESSAGE = 'SET_MESSAGE'
export const SET_CURRENT_POSITION = 'SET_CURRENT_POSITION'
export const SET_MEMO = 'SET_MEMO'
export const TOGGLE_LAYER = 'TOGGLE_LAYER'
export const TOGGLE_OFFCANVAS = 'TOGGLE_OFFCANVAS'
export const POPUP = 'POPUP'
export const VISIBLE_SETTINGS_BY_USER = 'VISIBLE_SETTINGS_BY_USER'
